export const normalizeUiLanguage = value => {
 const code = String(value || "").trim().toLowerCase();
 if (["ar", "arb", "ara", "arabic"].includes(code)) return "arb";
 return "eng";
};
export const resolveUiLanguage = value => {
 const code = normalizeUiLanguage(value);
 if (process.env.REACT_APP_ENGLISH_PRESENTATION !== "true" || process.env.REACT_APP_ARABIC_UI === "true") return code;
 return code === "arb" && process.env.REACT_APP_ARABIC_UI === "true" ? "arb" : "eng";
};
export const languageDirection = value => normalizeUiLanguage(value) === "arb" ? "rtl" : "ltr";
export const languageCode = value => ({eng:"en",arb:"ar"})[normalizeUiLanguage(value)];
